/*
    This file contains functionality common with all (!) inputs / atoms in our system
*/
export default {
	props: {
		hideDetails: { type: Boolean, default: true }, // most element in our app are not part of a form and will not show details
	},
};
